import fetch from "./configure";

export const searchSchool = params => fetch.get("/searchSchool", { params });
export const getSchoolDetail = params => fetch.get("/getSchoolDetail", { params });
export const doFollow = data => fetch.post("/doFollow", data);
